import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const pageApi = {
  getPageConfigByPageToken: (page_token) => {
    return instance().get('v1/pageconfig', {
      headers: {
        AUTHORIZATION: `Bearer ${page_token}` || `Bearer ${store.state.pageToken}`
      }
    })
  }
}
export default pageApi



// WEBPACK FOOTER //
// ./src/api/page.js